module.exports = __webpack_public_path__ + "img/group-check-on.7695333a.svg";